import * as React from 'react'
import { ReactElement, useContext, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { IBackgroundLocationState } from '../../../config/appConfig'
import PopupContext from '../../../context/PopupContext'

/**
 * The `add-task` command - the Outlook ribbon button, among others - no longer has a dialog of its own: it opens the
 * global task popup and returns to the screen the command was fired from (HAM-4275). Rendering nothing is the point;
 * the popup lives in PopupContext, above the router.
 */
export default function AddTaskCommand(): ReactElement {
    const history = useHistory<IBackgroundLocationState>()
    const location = useLocation<IBackgroundLocationState>()
    const popupContext = useContext(PopupContext)

    useEffect(() => {
        popupContext.setShowTaskDialog({})
        history.replace(location.state?.background?.pathname ?? '/')
    }, [])

    return <></>
}
